import React from 'react';

import { Provider } from "react-redux";

import { createTheme, ThemeProvider } from '@mui/material';

import { AppRouter } from "./routers/AppRouter";

import { store } from './store';

const theme = createTheme({
    palette: {
        primary: {            
            main: '#252B50',
        },
        secondary: {
            main: '#63a544',
        },        
    },
    components: {
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#252B50 !important',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#252B50 !important',
                        },
                        '&:focus': {
                            backgroundColor: '#252B50 !important',
                        },
                    },
                    '&.MuiPickersDay-today:not(.Mui-selected)': {
                        border: '1.5px solid #252B50',
                    },
                },
            },
        },
    },
});

function App() {

    return (

        <Provider store = { store }>

            <ThemeProvider theme={theme}>
            
                <AppRouter />
            
            </ThemeProvider>

        </Provider>
    );

}

export default App;
